import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_BEGIN,
  MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_SUCCESS,
  MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_FAILURE,
  MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import fileDownload from 'js-file-download';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';

export function exportAccountsData(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/exportManageAcc`,
        method: 'post',
        data: args,
        responseType: 'blob',
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExportAccountsDataError() {
  return {
    type: MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_DISMISS_ERROR,
  };
}

export function useExportAccountsData() {
  const dispatch = useDispatch();

  const { exportAccountsDataPending, exportAccountsDataError } = useSelector(
    state => ({
      exportAccountsDataPending: state.manageSubs.exportAccountsDataPending,
      exportAccountsDataError: state.manageSubs.exportAccountsDataError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(exportAccountsData(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissExportAccountsDataError());
  }, [dispatch]);

  return {
    exportAccountsData: boundAction,
    exportAccountsDataPending,
    exportAccountsDataError,
    dismissExportAccountsDataError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        exportAccountsDataPending: true,
        exportAccountsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_SUCCESS:
      // The request is success
      fileDownload(action.data, `Account Reports.xlsx`);
      return {
        ...state,
        exportAccountsDataPending: false,
        exportAccountsDataError: null,
      };

    case MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_FAILURE:
      // The request is failed
      return {
        ...state,
        exportAccountsDataPending: false,
        exportAccountsDataError: action.data.error,
      };

    case MANAGE_SUBS_EXPORT_ACCOUNTS_DATA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        exportAccountsDataError: null,
      };

    default:
      return state;
  }
}
